import { inject, Injectable, signal } from '@angular/core';
import { CommonHttpService } from '../common-http.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { IBecomeSponsorResponse } from '../../models/IBecomeSponsorResponse';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { IBecomeSponsorRequest } from '../../models/IBecomeSponsorRequest';


@Injectable({
  providedIn: 'root'
})
export class SponsorService {

  private httpService = inject(CommonHttpService);
  private http = inject(HttpClient);
  private _becomeSponsorTextSignal = signal<IBecomeSponsorResponse | null>(null);
  public becomeSponsorTextSignal = this._becomeSponsorTextSignal.asReadonly();


  constructor() { }

  getBecomeSponsorText(auctionId: number): Observable<IBecomeSponsorResponse> {

    const url = `${environment.apiUrl}/v3/auctions/${auctionId}/become-a-sponsor`;

    return this.httpService.get<IBecomeSponsorResponse>(url).pipe(
      tap(response => {
        // console.log('Become sponsor text response:', response);
        this._becomeSponsorTextSignal.set(response)

      }),
      catchError((error: HttpErrorResponse) => {
        const errorMsg =
          typeof error.error === 'string' ? error.error : 'Unknown Error';

        return throwError(() => new Error(errorMsg));
      })
    )
  }

  // postBecomeASponsor(auctionId: number, becomeSponsorRequest: IBecomeSponsorRequest): Observable<string> {

  //   const url = `${environment.apiUrl}/v3/auctions/${auctionId}/become-a-sponsor`;

  //   const body = new HttpParams()
  //     .set('becomeSponsorRequest', JSON.stringify(becomeSponsorRequest));

  //   console.log(body);
  //   let headers = new HttpHeaders()
  //     .set('Content-Type', 'application/x-www-form-urlencoded')
  //     .set('Accept', 'application/json');

  //   return this.http.post<string>(url, body.toString(), {
  //     headers,
  //     responseType: 'text' as 'json'
  //   }).pipe(
  //     tap(response => {
  //       console.log('response register account', response);
  //     }),
  //     catchError((error: HttpErrorResponse) => {
  //       console.log(error);
  //       return throwError(() => ({
  //         error: error.error

  //       }));
  //     })
  //   );
  // }

  postBecomeASponsor(auctionId: number, becomeSponsorRequest: IBecomeSponsorRequest, recaptchaToken: string): Observable<string> {
    const url = `${environment.apiUrl}/v3/auctions/${auctionId}/become-a-sponsor`;

    const body = new HttpParams()
      .set('fullName', becomeSponsorRequest.fullName)
      .set('email', becomeSponsorRequest.email)
      .set('organization', becomeSponsorRequest.organization || '')
      .set('phone', becomeSponsorRequest.phone || '')
      .set('comments', becomeSponsorRequest.comments || '')
      .set('countryCode', becomeSponsorRequest.countryCode || '')
      .set('address1', becomeSponsorRequest.address1 || '')
      .set('address2', becomeSponsorRequest.address2 || '')
      .set('zip', becomeSponsorRequest.zip || '')
      .set('city', becomeSponsorRequest.city || '')
      .set('region', becomeSponsorRequest.region || '')
      .set('g-recaptcha-response', recaptchaToken);

    const headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('Accept', 'application/json');

    return this.http.post<string>(url, body.toString(), {
      headers,
      responseType: 'text' as 'json'
    }).pipe(
      tap(response => {
        // console.log('response register sponsor', response);
      }),
      catchError((error: HttpErrorResponse) => {
        console.log(error);
        return throwError(() => ({
          error: error.error
        }));
      })
    );
  }


}
